export const generateRandomString = (length: number) => {
  const chars =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  const array = new Uint32Array(length);
  if (typeof window !== 'undefined' && window.crypto?.getRandomValues) {
    window.crypto.getRandomValues(array);
  } else if (
    typeof globalThis !== 'undefined' &&
    globalThis.crypto?.getRandomValues
  ) {
    globalThis.crypto.getRandomValues(array);
  } else {
    throw new Error('A secure random number generator is not available.');
  }
  for (let i = 0; i < length; i++) {
    result += chars.charAt(array[i] % chars.length);
  }
  return result;
};
